export default function Contact() {
    return (
        <main>
            <h1>Contact</h1>

            <section className="content">
                <p>This is contact, Thank you !</p>
            </section>
        </main>
    );
}